import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

// difficulty with unknown record
export const ViewType = iotsUtils.fromList(constants.report.timePerJobViewTypes);
